import React from 'react';
import translate from '@/utils/translate';
import type {CampaignPaidGigBriefItem} from '@/types/campaign';
import BriefItemHtml from '../../shared/BriefItemHtml';
import BriefSection from '../../shared/BriefSection';
import {getBriefItemByTitle} from '../../utils/briefItemFilters';

interface ContentAgreementProps {
  briefItems: CampaignPaidGigBriefItem[];
}

function ContentAgreement({briefItems}: ContentAgreementProps) {
  const item = getBriefItemByTitle(briefItems, 'Content agreement');
  if (!item) {
    return null;
  }
  return (
    <BriefSection title={translate('Content agreement')}>
      <BriefItemHtml contentHtml={item.contentHtml} />
    </BriefSection>
  );
}

export default ContentAgreement;
